import React from 'react';

const OriginationsBoardEmptyState = ({ title = 'Sin solicitudes', description, compact = false }) => (
  <div className={`originations-board__empty${compact ? ' is-compact' : ''}`}>
    <i className="bi bi-inbox" aria-hidden />
    <strong>{title}</strong>
    {description && <p>{description}</p>}
  </div>
);

export default OriginationsBoardEmptyState;
